import React, { useState, useEffect } from 'react'
import { JSONToHTMLTable, Loading } from '../../components'
import { GSXService } from '../../services'
import {RepairItemProps} from "./types";
import {AxiosResponse} from "axios";
export const RepairItem = ({ repairID }:RepairItemProps) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [response, setResponse] = useState<AxiosResponse | null>(null)


  useEffect(() => {
    setLoading(true)
    let data = {
      repairId: repairID,
    }

      new GSXService()
        .repair_details(data)
        .then((res) => {
          setResponse(res)
        })
        .catch((errors) => {
          setResponse(errors)
        }).finally(()=>{
          setLoading(false)
      })
  }, [])

  return (
      <>
        {loading && <Loading/>}
        {response && <JSONToHTMLTable
      data={response}
      tableClassName="table table-sm table-striped table-bordered"
    />}
   </>

  )
}
